import { makeAutoObservable, runInAction } from "mobx";

import { PromotionSummary } from "../PromotionSummary";
import { StockistIssue } from "../StockistIssue";

export class StockistBasketItemDTO {
  stockistId: number;
  issueId: number;
  magazineId: number;
  publisherId: number;
  quantity: number;
  isFreebieEligible: boolean;
  maxAvailableQuantity: number;
  validation: ItemValidationResult;
  issue: StockistIssue;
  issuePrice: number;
  issueDiscountPercentage: number;
  discountedIssuePrice: number;
  totalIssuePrice: number;
  totalDiscountedIssuePrice: number;
  singleIssueWeight: number;
  singleIssueThicknessMM: number;
  totalIssueWeight: number;
  totalIssueThicknessMM: number;
  // promo
  historicalSummary: PromotionSummary;
  freebiesDue: number;
  totalPurchased: number;
  freebiesInThisOrder: number;
  totalOrderQuantity: number;

  get totalIssueWeightKilograms(): number {
    return +((this.singleIssueWeight * this.quantity) / 1000).toFixed(2);
  }

  // UI state
  isUpdatingQuantity = false;

  setUpdatingQuantity(value: boolean) {
    runInAction(() => { this.isUpdatingQuantity = value; });
  }

  changeOrderedAmount(quantity: number) {
    runInAction(() => {
      this.quantity = Math.max(0, Math.min(quantity, this.maxAvailableQuantity));
      this.issue.updateInBasket(this.quantity);
    });
  }

  constructor(data: any) {
    this.stockistId = data.stockistId;
    this.issueId = data.issueId;
    this.magazineId = data.magazineId;
    this.publisherId = data.publisherId;
    this.quantity = data.quantity;
    this.isFreebieEligible = data.isFreebieEligible;
    this.maxAvailableQuantity = data.maxAvailableQuantity;
    this.validation = data.validation;
    this.issue = data.issue instanceof StockistIssue ? data.issue : new StockistIssue(data.issue);
    this.issuePrice = data.issuePrice;
    this.issueDiscountPercentage = data.issueDiscountPercentage;
    this.discountedIssuePrice = data.discountedIssuePrice;
    this.totalIssuePrice = data.totalIssuePrice;
    this.totalDiscountedIssuePrice = data.totalDiscountedIssuePrice;
    this.singleIssueWeight = data.singleIssueWeight;
    this.singleIssueThicknessMM = data.singleIssueThicknessMM;
    this.totalIssueWeight = data.totalIssueWeight;
    this.totalIssueThicknessMM = data.totalIssueThicknessMM;
    this.historicalSummary = data.historicalSummary;
    this.freebiesDue = data.freebiesDue;
    this.totalPurchased = data.totalPurchased;
    this.freebiesInThisOrder = data.freebiesInThisOrder;
    this.totalOrderQuantity = data.totalOrderQuantity;

    makeAutoObservable(this);
  }
}

export interface ItemValidationResult {
  issueId: number;
  isAvailable: boolean;
  isInStock: boolean;
  isStockistEligible: boolean;
  isUpcoming: boolean;
  itemCanBeProcessed: boolean;
}